import './index.css'

const NotFound = () => (
  <div className="main-container">
    <img
      src="https://assets.ccbp.in/frontend/react-js/not-found-blog-img.png"
      alt="not found"
      width="250px"
      className="img"
    />
    <h1 className="main-text">Not Found</h1>
  </div>
)

export default NotFound
